// extracted by mini-css-extract-plugin
export var details = "_lc-0";
export var inspectorPopover = "_lc-1";